import WindowScroller, { IS_SCROLLING_TIMEOUT } from './WindowScroller';

export default WindowScroller;
export { WindowScroller, IS_SCROLLING_TIMEOUT };


//////////////////
// WEBPACK FOOTER
// ./~/react-virtualized/dist/es/WindowScroller/index.js
// module id = 993
// module chunks = 4